import * as R from 'ramda';
import React, {cloneElement, Children}  from 'react';
import {SimpleFormIterator, FormInput} from 'react-admin';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Check from "@material-ui/icons/Check";
import ClearIcon from '@material-ui/icons/Clear';


export class TableFormIterator extends SimpleFormIterator {
    render() {
        const {basePath, fields, resource, record, source, children} = this.props;
        if (!fields) return null;
        const defaultValues = R.pathOr([], ['defaultValues', 'permissions'], this.props);
        let records = []
        if (R.isEmpty(defaultValues)) {
            records = R.pathOr([], [source], record);
        } else {
            records = defaultValues;
        }
        return (
            <Table style={{minWidth: 600, tableLayout: 'auto'}}>
                <TableBody>
                    {fields.map((member, index) => (
                        <TableRow  key={index}>
                            {Children.map(children, (input, index2) =>
                                (
                                    <FormInput
                                        basePath={input.props.basePath || basePath}
                                        input={cloneElement(input, {
                                            source: input.props.source
                                                ? `${member}.${input.props.source}` : member,
                                            index: input.props.source
                                                ? undefined : index2,
                                            label: input.props.label || input.props.source,
                                        })}
                                        record={
                                            (records && records[index] || {})
                                        }
                                        resource={resource}
                                    />
                                )
                            )}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        )
    }
}